import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { DocumentAttachment } from 'models';
import { BaseMenuComponent } from 'src/app/common/base-menu-component';

@Component({
  selector: 'app-document-attachments-menu',
  imports: [MatIconButton, MatIcon, MatMenu, MatMenuItem, MatMenuTrigger],
  templateUrl: './document-attachments-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './document-attachments-menu.component.scss',
})
export class DocumentAttachmentsMenuComponent extends BaseMenuComponent {
  /** Document attachments. */
  attachments = input.required<DocumentAttachment[]>();

  /**
   * Downloads the given attachment.
   *
   * @param attachment Document attachment.
   */
  downloadAttachment(attachment: DocumentAttachment): void {
    const arrayBuffer = attachment.bytes as ArrayBuffer;
    const blob = new Blob([new Uint8Array(arrayBuffer)]);
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = attachment.name; // Use the actual filename property
    link.click();
    URL.revokeObjectURL(url);
  }
}
